import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import useStyles from './Styles'

const Loading: React.FC = () => {
  const classes = useStyles()

  return (
    <Grid container direction={'column'} alignContent="center">
      <div className={classes.root}>
        <div className={classes.placeholder}>
          <CircularProgress />
        </div>
        <Typography id="page-loading-label" className={classes.label}>
          Loading...
        </Typography>
      </div>
    </Grid>
  )
}

export default Loading
